import { DictionaryEntries } from '@web-libs/core/internationalization/dictionary.types';

export const validateEmail = (
  email: string | undefined,
  dict: DictionaryEntries,
) => {
  if (!email) return true;
  // More restrictive regex that only allows ASCII letters, numbers, and common safe symbols
  // Local part: letters, numbers, dots, hyphens, underscores, plus signs
  // Domain part: letters, numbers, dots, hyphens (standard domain format)
  const regex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email) || dict.validator.emailInvalid;
};
